module.exports = __webpack_public_path__ + "img/Slide26.11bf9135.png";